import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { TextField } from "@material-ui/core";
import {
  eventStatuses,
  eventTypes,
  eventTypesEAP,
  eventTypesNthQLDPHN,
  eventTypesCentralisedService,
  eventTypesAdmin,
  paymentTypes,
  bookingTypes,
  bookingTypesNthQLDPHN,
  bookingLocation,
  sessionTypes,
  sessionTypesClinical,
  sessionTypesPsychiatrist,
  sessionTypesPsychologist,
  eventTypesPsychiatrist,
} from "./data";

export const TitleLabel = (props) => {
  return null;
};

export const TitleEditor = (props) => {
  return null;
};

export const StartTimezoneCheckedLabel = (props) => {
  return null;
};

export const StartTimezoneCheckedEditor = (props) => {
  return null;
};

export const DescriptionLabel = (props) => {
  return null;
};

export const DescriptionEditor = (props) => {
  return null;
};

export const EventTypeEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.value,
      });
    }
  };

  return (
    <DropDownList
      onChange={handleChange}
      value={
        props.admin
          ? eventTypesAdmin.find((t) => t.value === props.value)
          : props.centralisedservicePsychiatrist
            ? eventTypesPsychiatrist.find((t) => t.value === props.value)
            : props.nthqldphn
              ? eventTypesNthQLDPHN.find((t) => t.value === props.value)
              : props.centralisedservice
                ? eventTypesCentralisedService.find((t) => t.value === props.value)
                : props.eapcontractndis || props.eapAvailability
                  ? eventTypesEAP.find((t) => t.value === props.value)
                  : eventTypes.find((t) => t.value === props.value)
      }
      data={
        props.admin
          ? eventTypesAdmin
          : props.centralisedservicePsychiatrist
            ? eventTypesPsychiatrist
            : props.nthqldphn
              ? eventTypesNthQLDPHN
              : props.centralisedservice
                ? eventTypesCentralisedService
                : props.eapcontractndis || props.eapAvailability
                  ? eventTypesEAP
                  : eventTypes
      }
      dataItemKey={"value"}
      textField={"text"}
      style={{ width: 250 }}
    />
  );
};

const BOOKING_DURATIONS = {
  Normal: 60,
  P0101: 60,
  P0201: 60,
  P0102: 60,
  P0202: 60,
  P0103: 15,
  P0203: 15,
  P0304: 60,
  P0305: 60,
  P0306: 15,
  P0107: 15,
  P0207: 15,
  S0108: 15,
  S0208: 15,
  S0309: 15,
};

export const ClientEditor = (props) => {
  //console.log(props.value)
  const role = useSelector((state) => state.auth.roleDesc);
  const clients = useSelector((state) => state.admin.Clients);
  // Sort clients by surname (A → Z)
  const sortedClients = [...clients].sort((a, b) => (a.surname || "").localeCompare(b.surname || ""));

  const handleChange = (event) => {
    //console.log(event)
    const selectedClient = clients.find((client) => client.fullname === event.value.fullname);
    //console.log(selectedClient)
    if (selectedClient) {
      const id = selectedClient.id;
      //console.log(id)
      if (props.onChange) {
        props.onChange.call(undefined, {
          value: id,
        });
      }
    }
  };

  function handleClientSelectChange(propertyName, event, newValue) {
    // console.log('NewValue')
    // console.log(newValue);
    //  console.log(props);
    if (newValue) {
      //console.log(newValue)
      if (props.onChange) {
        props.onChange.call(undefined, {
          value: newValue.id,
        });
      }
      //
      // formRenderProps.onChange('paymentType', {
      //   value: newValue.paymentType
      // });
    }
  }

  if (role === "Admin") {
    return (
      <DropDownList
        onChange={handleChange}
        value={clients.find((client) => client.id === props.value)}
        data={sortedClients}
        dataItemKey={"id"}
        textField={"fullname"}
        disabled={props.disabled ? true : false}
        style={{ width: 240 }}
      />
    );
  } else {
    return (
      <Autocomplete
        id="clientSelect"
        variant="outlined"
        options={sortedClients}
        getOptionLabel={(option) => option.fullname}
        value={clients.find((client) => client.id === props.value) ? clients.find((client) => client.id === props.value) : null}
        onChange={(event, newValue) => handleClientSelectChange("clientSelect", event, newValue)}
        style={{
          fullWidth: true,
          display: "flex",
          wrap: "nowrap",
          position: "relative",
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            type="text"
            variant="outlined"
            margin="dense"
            name="clientSelector"
            style={{
              backgroundColor: "white",
              margin: 0,
              padding: 0,
              zIndex: "20000",
            }}
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password",
            }}
          />
        )}
      />
    );
  }
};

export const PaymentTypeEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      // Check if Payment Type is being changed to Contract and bounce it - this must be changed by Admin
      // Kendo React has no disabled support in DropDownList - though it exists in Angular - Telerik for the win.
      if (event.value.value && event.value.value !== "Contract") {
        props.onChange.call(undefined, {
          value: event.value.value,
        });
      }
    }
  };
  return (
    <DropDownList
      onChange={handleChange}
      itemDisabled="Contract"
      value={paymentTypes.find((t) => t.value === props.value)}
      data={paymentTypes}
      dataItemKey={"value"}
      textField={"text"}
      style={{ width: 200 }}
    />
  );
};

export const StatusEditor = (props) => {
  return (
    <DropDownList
      value={eventStatuses.find((t) => t.value === props.value)}
      readOnly
      data={[eventStatuses.find((t) => t.value === props.value)]}
      dataItemKey={"value"}
      textField={"text"}
    />
  );
};

export const BookingTypeEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.value,
      });
    }
  };
  return (
    <DropDownList
      onChange={handleChange}
      value={props.nthqldphn ? bookingTypesNthQLDPHN.find((t) => t.value === props.value) : bookingTypes.find((t) => t.value === props.value)}
      data={props.nthqldphn ? bookingTypesNthQLDPHN : bookingTypes}
      dataItemKey={"value"}
      textField={"text"}
      style={{ width: 200 }}
    />
  );
};

export const SessionTypeEditor = (props) => {
  const { value, onChange } = props;

  const data =
    props.providerType === "Psychologist" ? sessionTypesPsychologist : props.providerType === "Clinical" ? sessionTypesClinical : sessionTypesPsychiatrist;

  const selectedItem = data.find((t) => t.value === value);

  useEffect(() => {
    if (!value && data.length && onChange) {
      props.onChange.call(undefined, {
        value: data[0].value,
      });
    }
  }, [value, data, onChange]);

  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.value,
      });
    }
  };

  return <DropDownList onChange={handleChange} value={selectedItem} data={data} dataItemKey={"value"} textField={"text"} />;
};

export const BookingLocationEditor = (props) => {
  const handleChange = (event) => {
    if (props.onChange) {
      props.onChange.call(undefined, {
        value: event.value.value,
      });
    }
  };

  // console.log(props);
  return (
    <DropDownList
      onChange={handleChange}
      value={bookingLocation.find((t) => t.value === props.value)}
      data={bookingLocation}
      dataItemKey={"value"}
      textField={"text"}
    />
  );
};

export const CustomEndEditor = (props) => {
  const { value, onChange, eventType, bookingCode, start } = props;

  const previousBookingCode = React.useRef();

  React.useEffect(() => {
    if (!start || !(start instanceof Date)) {
      return;
    }

    // Only run:
    // 1. first load
    // 2. bookingCode changes
    const bookingCodeChanged = previousBookingCode.current !== bookingCode;

    if (previousBookingCode.current !== undefined && !bookingCodeChanged) {
      return;
    }

    let duration = 60;

    if (bookingCode && BOOKING_DURATIONS[bookingCode]) {
      duration = BOOKING_DURATIONS[bookingCode];

      // console.log(`Setting duration based on booking code ${bookingCode}: ${duration} minutes`);
    } else if (eventType === "booking") {
      duration = 60;

      //console.log(`Setting duration for generic booking: ${duration} minutes`);
    }

    const newEnd = new Date(start);
    newEnd.setMinutes(newEnd.getMinutes() + duration);

    onChange({
      value: newEnd,
    });

    previousBookingCode.current = bookingCode;
  }, [start, bookingCode, eventType, onChange]);

  return <DateTimePicker value={value} onChange={onChange} format="dd/MM/yyyy hh:mm a" width={"200px"} steps={{ minute: 15 }} />;
};
